<div *ngFor="let section of kycSections">
  <div [innerHTML]="section.description" style="margin-bottom: 12px;"></div>
  <smart-form [fields]="section.fields"></smart-form>
</div>
